<template>
  <div class="Paylist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right:-10px;color:rgba(52,152,219,1);"
        ></i>
        订单列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting(1)">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
        <div style="float: right;line-height: 46px;padding-right: 30px;">
          <el-select v-model="sort" size="small" placeholder="请选择">
            <el-option
              v-for="item in sort_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button
            style="margin-left:20px"
            size="small"
            type="primary"
            @click="export_payments_days()"
          >导出订单</el-button>
        </div>
      </div>
      <div style="background-color:#fff;" class="search_box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">订单编号:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="orderCode" clearable size="small" placeholder="订单编号"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">电话:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="mobile" clearable size="small" placeholder="电话"></el-input>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting(1)">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="content_box">
        <div class="table_title">
          <div class="table_title_box">
            <div class="title_icon">
              <i class="fas fa-bars"></i>
            </div>
            <div class="title_text">数据列表</div>
          </div>
        </div>
        <div class="table">
          <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
            <el-table-column prop="address" label="收货人信息" align="center"></el-table-column>
            <el-table-column prop="bind_mobile" width="110" label="电话" align="center"></el-table-column>
            <el-table-column width="200" label="订单编号" align="center">
              <template slot-scope="scope">
                <router-link target="_blank" :to="'./d_viewOrde/'+ scope.row.id + '/' + 1">
                  <div>{{scope.row.orderCode}}</div>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column prop="pay_money" width="80" label="需付金额" align="center"></el-table-column>
            <el-table-column width="240" label="提交时间/到期时间" align="center">
              <template slot-scope="scope">
                <div>
                  提交时间：{{scope.row.create_time}}
                  <br />
                  到期时间：{{scope.row.pay_days_end}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="订单状态" width="80" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center" name="bianji">
              <template slot-scope="scope">
                <button @click="del(scope.row.orderCode)" class="button1">提醒付款</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box clearfix">
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page.sync="page"
              @current-change="setPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 确认采购 -->
    <el-dialog title="提醒付款" :visible.sync="dialogFormVisible2" width="33%">
      <el-form>
        <el-form-item label="订单编号:">
          <el-input style="width:356px" v-model="order" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="订单货期:">
          <el-input
            style="width:356px"
            placeholder="请输入期限/单位为天"
            v-model="order_date"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submit1()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      order: "",
      order_date: "",
      id: "",
      dialogFormVisible2: false,
      orderCode: "",
      resType: null,
      option: [],
      value: "",
      odd: "",
      msg: "",
      select: false,
      selectAll: false,
      msg1: "",
      tableData: [],
      page: 1,
      total: 0,
      mobile: "",
      token: "",
      username: "",
      sort_option: [
        {
          value: "1",
          label: "账期时间"
        },
        {
          value: "2",
          label: "创建时间"
        }
      ],
      sort: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 3;
    this.$store.state.leftTitle = "账期提醒";
    this.geting(1);
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    export_payments_days() {
      this.$message({
        message: "excel导出成功",
        type: "success",
        offset: 200
      });
      window.location.href =
        this.serve + "/excel/export_payments_days?sort=" + this.sort;
    },
    shipments(id) {
      //确认发货弹窗s
      const _this = this;
      this.axios
        .get(this.serve + "/admin/get_express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error(this.msg1);
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "发货成功",
        type: "success"
      });
    },
    submit(id) {
      //确认发货弹窗提交
      const _this = this;
      this.axios
        .get(this.serve + "/admin/shipments", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id,
            express_com: this.value,
            express_code: this.odd
          }
        })
        .then(res => {
          this.msg1 = res.data.msg;
          if (res.data.status == "success") {
            _this.open();
            _this.geting(1);
            _this.heading();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    red(id) {
      this.$router.push("d_viewOrde?id=" + id);
    },
    del(orderCode) {
      this.$confirm("此操作将会提醒付款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/payment_days_alert", {
              params: {
                username: this.username,
                token: this.token,
                orderCode: orderCode
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "提醒成功"
                });
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    payment(orderCode) {
      //提醒付款
      this.$confirm("此操作将提醒付款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/warn_user_pay", {
              params: {
                username: this.username,
                token: this.token,
                orderCode
              }
            })
            .then(res => {
              this.msg = res.data.msg;
              if (res.data.status == "success") {
                this.geting(1);
                this.heading();
                this.$message({
                  type: "success",
                  message: "提醒成功!"
                });
              } else if (res.data.status == "error") {
                this.$message.error(this.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },
    setPage(v) {
      //分页
      this.page = Number(v);
      this.geting(v);
    },

    geting(page) {
      //请求数据
      var that = this;
      this.page = Number(page);
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      var where = {
        token: this.token,
        username: this.username,
        page: page
      };
      if (this.orderCode) {
        where.orderCode = this.orderCode;
      }
      if (this.mobile) {
        where.mobile = this.mobile;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .get(this.serve + "/admin/payment_days_list", {
          params: where
        })
        .then(res => {
          loading.close();
          that.tableData = [];
          var json = res.data;
          if (json.status == "success") {
            var json = json.data;
            that.page = Number(json.page);
            that.total = json.total;
            for (var key in json.results) {
              var timeNew = new Date(
                parseInt(json.results[key].create_time) * 1000
              )
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].create_time = timeNew;
              var timeNew1 = new Date(
                parseInt(json.results[key].pay_days_end) * 1000
              )
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].pay_days_end = timeNew1;
              that.tableData.push(json.results[key]);
              switch (json.results[key].status) {
                case 0:
                  json.results[key].status = "待付款";
                  break;
                case 1:
                  json.results[key].status = "待采购";
                  break;
                case 2:
                  json.results[key].status = "待发货";
                  break;
                case 3:
                  json.results[key].status = "待收货";
                  break;
                case 4:
                  json.results[key].status = "待评价";
                  break;
                case 5:
                  json.results[key].status = "已完成";
                  break;
                case 6:
                  json.results[key].status = "已取消";
                  break;
              }
            }
           
          } else {
            if (json.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Paylist {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search_box {
    border: 1px solid rgba(221, 221, 221, 1);
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>